import { create } from "zustand";

export const selectCountry = (state) => state.country;

const useCountryStore = create((set) => ({
  country: { isCurrent: false, data: [] },
  setCountry: (data) => set({ country: { isCurrent: true, data } }),
  reset: () => set({ country: { isCurrent: false, data: [] } }),
}));

export default useCountryStore;
